import React from 'react';

const PrivacyPolicy = () => {
  return (
    // 1. PAGE BACKGROUND (Cream Theme)
    <div style={{ backgroundColor: '#FFF8E7', minHeight: '100vh', padding: '60px 20px' }}>
      
      {/* 2. THE DOCUMENT CARD (White Paper Effect) */}
      <div className="container" style={{ 
          maxWidth: '900px', 
          backgroundColor: '#ffffff', 
          borderRadius: '15px', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
          padding: '40px 40px',
          border: '1px solid #f0e6d2' 
      }}>
        
        {/* HEADER */}
        <div className="text-center mb-5">
          <h1 className="fw-bold" style={{ fontFamily: 'serif', color: '#333', fontSize: '2.5rem' }}>
            Privacy Policy
          </h1>
          {/* Gold Underline */}
          <div style={{ width: '100px', height: '3px', backgroundColor: '#FFC35B', margin: '15px auto' }}></div>
          <p className="text-muted" style={{ fontSize: '0.9rem', letterSpacing: '1px' }}>LAST UPDATED: DECEMBER 2025</p>
        </div>

        <div className="policy-content" style={{ fontFamily: 'Georgia, serif', color: '#444', lineHeight: '1.8' }}>
          
          <p style={{ fontSize: '1.1rem', marginBottom: '40px', textAlign: 'center', fontStyle: 'italic' }}>
            Divine Depot ("we") are committed to protecting the privacy of our users. This Privacy Policy explains how we collect, use, disclose, and store your personal information when you use our website and services.
          </p>

          {/* SECTION 1 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              1. Information We Collect
            </h4>
            <p className="mb-3">We collect several types of information from and about users of our Website and Services:</p>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="mb-3">
                    <strong style={{ color: '#333' }}>Information you provide directly:</strong> This includes information you provide when you create an account, place an order, contact customer support, or participate in surveys. This may include your name, billing and shipping address, email address, phone number, and payment information.
                </li>
                <li className="mb-3">
                    <strong style={{ color: '#333' }}>Information collected automatically:</strong> When you use the Website or Services, we may automatically collect certain information about your device and usage, such as your IP address, browser type, operating system, referring URL, pages visited, and time spent on the Website.
                </li>
                <li className="mb-3">
                    <strong style={{ color: '#333' }}>Information from third parties:</strong> We may collect information about you from third-party sources, such as social media platforms, if you connect your account to one of these services.
                </li>
            </ul>
          </div>

          {/* SECTION 2 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              2. Use of Information
            </h4>
            <p className="mb-3">We use the information we collect for the following purposes:</p>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="mb-2">To provide and operate the Website and Services.</li>
                <li className="mb-2">To process your orders and transactions.</li>
                <li className="mb-2">To send you promotional emails and communications.</li>
                <li className="mb-2">To personalize your experience on the Website and Services.</li>
                <li className="mb-2">To improve the Website and Services.</li>
                <li className="mb-2">To analyze how users use the Website and Services.</li>
                <li className="mb-2">To comply with the law.</li>
            </ul>
          </div>

          {/* SECTION 3 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              3. Disclosure of Information
            </h4>
            <p>We may disclose your information to third-party service providers who help us operate the Website and Services. These service providers are contractually obligated to keep your information confidential and secure. We may also disclose your information if we are required to do so by law or in the good faith belief that such disclosure is necessary to comply with a court order, subpoena, or other legal process.</p>
          </div>

          {/* SECTION 4 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              4. Your Choices
            </h4>
            <p>You can opt out of receiving promotional emails from us by following the unsubscribe instructions in those emails. You can also access and update your personal information through your account settings.</p>
          </div>

          {/* SECTION 5 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              5. Data Security
            </h4>
            <p>We take reasonable steps to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no internet transmission or electronic storage is completely secure, so we cannot guarantee the security of your information.</p>
          </div>

          {/* SECTION 6 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              6. Children's Privacy
            </h4>
            <p>Our Website and Services are not directed to children under the age of 13. We do not knowingly collect personal information from children under 13.</p>
          </div>

          {/* SECTION 7 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              7. Changes to this Privacy Policy
            </h4>
            <p>We may update this Privacy Policy from time to time. We will post any changes on the Website. You are advised to periodically review this Privacy Policy for any changes.</p>
          </div>

          {/* SECTION 8 */}
          <div className="mb-4" style={{ backgroundColor: '#fffcf5', padding: '20px', borderRadius: '10px', border: '1px dashed #d4a017' }}>
            <h4 className="fw-bold" style={{ color: '#d4a017', marginBottom: '10px' }}>
              8. Contact Us
            </h4>
            <p className="mb-0">
              If you have any questions about this Privacy Policy, please contact us at: <br/>
              <a href="mailto:info@divinedepot.in" style={{ color: '#333', fontWeight: 'bold', textDecoration: 'none', borderBottom: '2px solid #FFC35B' }}>
                info@divinedepot.in
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;